import { render, staticRenderFns } from "./modalRefundCancel.vue?vue&type=template&id=47522810&scoped=true"
import script from "./modalRefundCancel.vue?vue&type=script&lang=js"
export * from "./modalRefundCancel.vue?vue&type=script&lang=js"
import style0 from "./modalRefundCancel.vue?vue&type=style&index=0&id=47522810&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47522810",
  null
  
)

export default component.exports